import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBarChart4Bars = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_10035_25420",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_10035_25420)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M2.0835 17.0834V15.8334H17.9168V17.0834H2.0835ZM2.91683 14.6795V9.58342H5.00016V14.6795H2.91683ZM6.93933 14.6795V5.41675H9.02266V14.6795H6.93933ZM10.9697 14.6795V7.91675H13.0531V14.6795H10.9697ZM15.0002 14.6795V2.91675H17.0835V14.6795H15.0002Z",
			fill: "#064C68"
		})
	})]
});
export default SvgBarChart4Bars;
